import { render, staticRenderFns } from "./IInputComponent.vue?vue&type=template&id=802dcb44&"
import script from "./IInputComponent.vue?vue&type=script&lang=js&"
export * from "./IInputComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports